/**
 * Compare app version rows (policy pickers) using x.y.z semver and build_number tie-break.
 * Matches AppVersion form: /^\d+\.\d+\.\d+$/
 */

const VERSION_NAME_RE = /^\d+\.\d+\.\d+$/;

function parseVersionTriple(versionName) {
  const s = String(versionName || '').trim();
  if (!VERSION_NAME_RE.test(s)) return null;
  const parts = s.split('.').map((x) => Number(x));
  return parts.length === 3 && parts.every((n) => Number.isFinite(n)) ? parts : null;
}

function buildNumberValue(row) {
  const b = row?.build_number;
  if (b == null || b === '') return 0;
  const n = Number(b);
  return Number.isFinite(n) ? n : 0;
}

/**
 * @param {object} a - version row
 * @param {object} b - version row
 * @returns {number} negative if a < b, positive if a > b, 0 if equal; NaN if incomparable
 */
export function compareAppVersionRows(a, b) {
  const pa = parseVersionTriple(a?.version_name);
  const pb = parseVersionTriple(b?.version_name);
  if (!pa || !pb) return NaN;
  for (let i = 0; i < 3; i += 1) {
    if (pa[i] !== pb[i]) return pa[i] - pb[i];
  }
  return buildNumberValue(a) - buildNumberValue(b);
}

/**
 * Whether `candidate` may appear in the "latest recommended" list when `minimum` is selected.
 * Unparseable candidates are excluded when minimum parses; if minimum does not parse, no filtering.
 */
export function isLatestCandidateAtLeastMin(candidate, minimum) {
  if (!minimum) return true;
  if (!parseVersionTriple(minimum.version_name)) return true;
  const c = compareAppVersionRows(candidate, minimum);
  if (Number.isNaN(c)) return false;
  return c >= 0;
}
